export default {"src":"/_next/static/media/pinterest.bec40d6d.svg","height":20,"width":18,"blurWidth":0,"blurHeight":0};